import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { Rocket, ArrowRight } from "lucide-react";

export default function LoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@emhost.local");
  const [password, setPassword] = useState("emhost123");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative grid place-items-center px-4">
      <div className="absolute inset-0 hero-accent pointer-events-none" />
      <Card className="relative w-full max-w-md p-8 border-border">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-lg grid place-items-center"
               style={{ background: "hsl(188 86% 45%)" }}>
            <Rocket className="h-4 w-4" style={{ color: "hsl(222 47% 7%)" }} />
          </div>
          <div>
            <div className="text-lg font-semibold tracking-tight">emhost</div>
            <div className="text-xs text-muted-foreground">Ship any ZIP. Any stack. Your VPS.</div>
          </div>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              data-testid="login-email-input"
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              data-testid="login-password-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <Button
            data-testid="login-submit-button"
            type="submit"
            disabled={busy}
            className="w-full gap-2"
          >
            Sign in <ArrowRight className="h-4 w-4" />
          </Button>
        </form>

        <div className="mt-6 text-xs text-muted-foreground border-t border-border pt-4">
          Default admin: <code className="font-mono">admin@emhost.local</code> / <code className="font-mono">emhost123</code>.
          Change it from Settings after login.
        </div>
      </Card>
    </div>
  );
}
